// extracted by mini-css-extract-plugin
export default {"productsPage":"products_productsPage__hcVx2"};